import useAnalytics from "./useAnalytics"; // Import the custom hook

const TrackPageViews = () => {
    useAnalytics(); // Just call the hook directly, no useEffect needed
    return null;
};

export default TrackPageViews;